var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textBox"},[_vm._v(_vm._s(_vm.vnText)+_vm._s(_vm.thText))])
}
var staticRenderFns = []

export { render, staticRenderFns }